import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import { ArrowLongLeftIcon } from '@heroicons/react/24/solid';
import $ from 'jquery';
import { useAlert } from "react-alert";
import axios from "axios";
import Tooltip from '../common/tooltip.js';
import { PencilIcon, NoSymbolIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const ValuesAwards = () => {
    const [isValuesOpen, setIsValuesOpen] = useState(true);
    const [isAwardsOpen, setIsAwardsOpen] = useState(false);
    const [badges, setBadges] = useState([]);
    const alert = useAlert();

    const handlechange = (string) => {

        if (string == 'values') {
            setIsValuesOpen(true);
            setIsAwardsOpen(false);
        } else if (string == 'awards') {
            setIsAwardsOpen(true);
            setIsValuesOpen(false);
        }
    }

    useEffect(() => {

        axios({
            url: process.env.REACT_APP_API_URL + "api/badges/allbadges",
            method: "GET",
        })
            .then((res) => {
                if (res.data.issuccessful) {
                    setBadges(res.data.badges);
                }
            })

            .catch((err) => {
                console.error('There was an error!', err);
            });
    }, [])

    $(document).ready(function () {
        setTimeout(function () {
            $('#myTable').DataTable();
        }, 1000);
    })

    const disableBadge = (id) => {
        // console.log("disable", id);
        axios.post(process.env.REACT_APP_API_URL + "api/badges/disablebadge", {
            id,
        })
            .then(function (response) {
                if (response.data.issuccessful) {
                    alert.success(response.data.message)
                    setTimeout(() => {
                        window.location.reload(false)
                    }, 1500)
                } else {
                    alert.error(response.data.message)
                }
            })
            .catch(function (error) {
                alert.error(error);
            });
    }

    const enableBadge = (id) => {
        // console.log("enable", id);
        axios.post(process.env.REACT_APP_API_URL + "api/badges/enablebadges", {
            id,
        })
            .then(function (response) {
                if (response.data.issuccessful) {
                    alert.success(response.data.message)
                    setTimeout(() => {
                        window.location.reload(false)
                    }, 1500)
                } else {
                    alert.error(response.data.message)
                }
            })
            .catch(function (error) {
                alert.error(error);
            });
    }

    return (
        <div style={{ position: "relative" }} className="rewardRequest">
            <div style={{ display: "flex", justifyContent: "space-between" }} className='admin-header'>
                <Link to="/admin" style={{ display: "flex", gap: '10px', color: 'black' }}>
                    <ArrowLongLeftIcon className="" style={{ width: '30px' }} />
                    <p style={{ marginBottom: '0' }} >Core Values & Awards</p>
                </Link>
                {isValuesOpen && (
                    <Link to="/admin/core-values-awards/add-values" style={{ backgroundColor: "#008bff", color: '#fff', borderRadius: "30px", padding: '5px 20px' }}>Add Core Values</Link>
                )}

                {isAwardsOpen && (
                    <Link to="" style={{ backgroundColor: "#008bff", color: '#fff', borderRadius: "30px", padding: '5px 20px' }}>Add Awards</Link>
                )}
            </div>

            <div style={{ marginTop: "40px", backgroundColor: "white", padding: "20px", borderRadius: "8px", }}>
                <div style={{ display: 'flex', gap: '15px' }}>
                    <p className={`${isValuesOpen ? "values-selected" : ""}`} style={{ cursor: 'pointer' }} onClick={() => handlechange('values')}>Core Values</p>
                    <p className={`${isAwardsOpen ? "values-selected" : ""}`} style={{ cursor: 'pointer' }} onClick={() => handlechange('awards')}>Awards</p>
                </div>

                {isValuesOpen && (
                    <div>
                        <table id="myTable" className="display table table-hover" data-page-length='10'>
                            <thead>
                                <tr>
                                    <th>Core Values</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {badges.map((badge, index) => {

                                    return (
                                        <tr key={index} id={badge.BadgeID}>
                                            <td>
                                                <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
                                                    <img
                                                        src={process.env.REACT_APP_API_URL + "api/images/badges/" + badge.BadgeImage}
                                                        alt="Badge Image"
                                                        style={{ width: "70px" }}
                                                    />
                                                    {badge.BadgeName}
                                                </div>

                                            </td>

                                            <td>{badge.IsActive == 1 ? "Active" : "Disabled"}</td>


                                            <td className='d-flex' style={{ alignItems: 'center', color: "#000", justifyContent: "space-around", padding: "12px", height: "40px", gap: "10px" }}>
                                                <Tooltip text="Edit core value"><Link to={`/admin/core-values-awards/edit-values/${btoa(badge.BadgeID)}`} style={{ color: '#000', height: '18px' }}><PencilIcon style={{ width: '18px' }} data-id={badge.BadgeID} /></Link></Tooltip>
                                                {badge.IsActive == 1 ? (
                                                    <Tooltip text="Disable core value"><NoSymbolIcon style={{ width: '18px' }} className='delete-btn' onClick={() => disableBadge(badge.BadgeID)} /></Tooltip>
                                                ) : (
                                                    <Tooltip text="Enable core value"><CheckCircleIcon style={{ width: '18px', cursor: 'pointer' }} className='enable-btn' onClick={() => enableBadge(badge.BadgeID)} /></Tooltip>
                                                )}

                                            </td>

                                        </tr>
                                    )
                                })}
                            </tbody>
                        </table>
                    </div>
                )}

                {isAwardsOpen && (
                    <div>
                        Coming Soon !!!
                    </div>
                )}


            </div>


        </div>
    )
}

export default ValuesAwards;